import type { ComponentStyleConfig} from '@chakra-ui/react'
import { defineStyle, theme } from '@chakra-ui/react'

const baseStylePopper = defineStyle({ zIndex: theme.zIndices.popover })

export const Popover: ComponentStyleConfig = {
  // style object for base or default style
  baseStyle: {
    popper: baseStylePopper,
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {
    lg: {
      width: 'lg',
    },
  },
  // styles for different visual variants ("outline", "solid")
  variants: {},
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: '',
    variant: '',
    colorScheme: '',
  },
}
